import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { handleRouteChange } from "../lib/googleAds";

// Envia page_view ao Google Ads só nas rotas públicas (ver lib/googleAds).
const GoogleAdsTracker = () => {
  const { pathname } = useLocation();
  const prev = useRef(null);

  useEffect(() => {
    // Espera o <Seo /> da página atualizar o document.title.
    const id = setTimeout(() => {
      handleRouteChange(pathname, prev.current);
      prev.current = pathname;
    }, 0);
    return () => clearTimeout(id);
  }, [pathname]);

  return null;
};

export default GoogleAdsTracker;
